
/* injects from baggage-loader */

/*
 * api Template service
 */

const moduleTemplate = angular.module('api.template', []);

moduleTemplate.factory('Template', [
  "$timeout", "ns", "$injector", "$state", "Restangular", "$http", "$templateCache", "Section", "Email",
  ($timeout, ns, $injector, $state, Restangular, $http, $templateCache, Section, Email) => {
    const {pageId, siteId, emailId, formId, lessonId} = $state.params;

    return {
      getStylesheet: () => {
        switch (Editor.mode) {
          case "site.page.editor":
            return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).customGET("sections.css", {
              global_site_id: window.justclick.userSiteId || ''
            });
          case "email.page.editor":
            return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).customGET("sections.css");
          case "form.page.editor":
            return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).customGET("sections.css");
          case "lesson.page.editor":
            return Restangular.all("lms_pages").one($state.params.lessonId).all("pages").one($state.params.pageId).customGET("sections.css");
        }
      },
      loadHTML: () => {
        switch (Editor.mode) {
          case "editor.section":
            return Section.getPublicSectionHTML($state.params.sectionId);
          case "site.page.editor":
            return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).customGET("sections.html", {
              global_site_id: window.justclick.userSiteId || ''
            });
          case "email.page.editor":
            return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).customGET("sections.html");
          case "form.page.editor":
            return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).customGET("sections.html");
          case "lesson.page.editor":
            return Restangular.all("lms_pages").one($state.params.lessonId).all("pages").one($state.params.pageId).customGET("sections.html");
        }
      },
      loadJSON: () => {
        switch (Editor.mode) {
          case "editor.section":
            return Restangular.all("sections").one($state.params.sectionId).get();
          case "site.page.editor":
            return Restangular.all("sites").one($state.params.siteId).all("pages").one($state.params.pageId).one("sections").get({
              global_site_id: window.justclick.userSiteId || ''
            });
          case "email.page.editor":
            return Restangular.all("emails").one($state.params.emailId).all("pages").one($state.params.pageId).one("sections").get();
          case "form.page.editor":
            return Restangular.all("web_forms").one($state.params.formId).all("pages").one($state.params.pageId).one("sections").get();
          case "lesson.page.editor":
            return Restangular.all("lms_pages").one($state.params.lessonId).all("pages").one($state.params.pageId).one("sections").get();
        }
      },
      getAll: () => {
        return Restangular.one("templates.json").get();
      },
      getEmailTemplates: () => {
        return Restangular.one("email_templates.json").get({fromDashboard: true});
      },
      get: (siteSlug) => {
        return Restangular.all("templates").one(siteSlug).get();
      },
      getUserCategories: () => {
        return Restangular.all("templates").all("tags?user_tags=1").getList();
      },
      getEmailUserCategories: () => {
        return Restangular.all("email_templates").all("tags?user_tags=1").getList();
      },
      sortEmailCategories: (tags) => {
        return Restangular.all("email_templates").all("tags_sort").post({
          tags: tags
        });
      },
      sortCategories: (tags) => {
        return Restangular.all("templates").all("tags_sort").post({
          tags: tags
        });
      },
      getWebFormTemplates: () => {
        return Restangular.one("web_forms").get({fromDashboard: true});
      },
      getWebFormUserCategories: () => {
        return Restangular.all("web_form_templates").all("tags?user_tags=1").getList();
      },
      sortWebFormCategories: (tags) => {
        return Restangular.all("web_form_templates").all("tags_sort").post({
          tags: tags
        });
      },

      getLessonTemplates: () => {
        return Restangular.one("lms_page_templates.json").get({
          from_admin_panel: true
        });
      },
      getLessonUserCategories: () => {
        return Restangular.all("lms_page_templates").all("tags?user_tags=1").getList();
      },
      sortLessonCategories: (tags) => {
        return Restangular.all("lms_page_templates").all("tags_sort").post({
          tags: tags
        });
      },
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/api/template.js